export default {
  title: 'Nagrody',
  guest: {
    eyebrow: 'Nagrody',
    headline: 'Każde zamówienie przynosi Ci <highlight>nagrody</highlight>',
    subheading_one: 'Zdobywaj {{count}} punkt za każde wydane {{amount}}.',
    subheading_few: 'Zdobywaj {{count}} punkty za każde wydane {{amount}}.',
    subheading_many: 'Zdobywaj {{count}} punktów za każde wydane {{amount}}.',
    subheading_other: 'Zdobywaj {{count}} punktów za każde wydane {{amount}}.',
    cta: 'Zarejestruj się i zacznij zdobywać punkty',
    already_member: 'Masz już konto?',
    sign_in: 'Zaloguj się',
    redeemable_heading: 'Twoje punkty = darmowe jedzenie',
    redeemable_eyebrow: '🎁 Nagrody do odblokowania',
  },
  member: {
    balance_label: 'Twoje saldo',
    balance_suffix: 'punktów · wartość <highlight>{{amount}}</highlight>',
    next_reward: 'Następna nagroda przy <highlight>{{points}} pkt</highlight>',
    redeem_hint: '✓ Możesz wymienić do {{points}} pkt ({{amount}}) przy następnym zamówieniu',
    expiration_zero: '⏳ {{points}} pkt wygasa dzisiaj',
    expiration_one: '⏳ {{points}} pkt wygasa za 1 dzień',
    expiration_few: '⏳ {{points}} pkt wygasa za {{count}} dni',
    expiration_many: '⏳ {{points}} pkt wygasa za {{count}} dni',
    expiration_other: '⏳ {{points}} pkt wygasa za {{count}} dni',
    pts_lifetime: 'Ważność punktów',
    saved_lifetime: 'Łączne oszczędności',
    cta: 'Zamów teraz',
    redeemable_heading: 'Co możesz wymienić',
    redeemable_eyebrow: 'Masz {{points}} pkt ({{amount}})',
    redeemable_description:
      'Do {{maxPoints}} pkt ({{maxAmount}}) na zamówienie. Pozycje poniżej {{maxAmount}} są całkowicie bezpłatne.',
  },
  items: {
    free: 'GRATIS',
    save: 'Oszczędź {{amount}}',
  },
  history: {
    eyebrow: 'Historia',
    title: 'Ostatnia aktywność',
    load_more: 'Wczytaj więcej',
    sources: {
      welcome_bonus: 'Bonus powitalny',
      google_review_reward: 'Nagroda za recenzję Google',
      reward_loyalty_program_conversion: 'Konwersja programu lojalnościowego',
      cashback: 'Zdobyty cashback',
      refund: 'Zamówienie zwrócone',
      cashback_usage: 'Punkty wykorzystane',
      cashback_usage_refund: 'Zwrot realizacji',
      expired_points_void: 'Punkty wygasły',
      mobile_app_signup_bonus: 'Bonus za rejestrację w aplikacji',
    },
    detail_with_order: 'Zamówienie #{{number}} · {{amount}}',
  },
  how_it_works: {
    eyebrow_guest: 'Proste i automatyczne',
    eyebrow_member: 'Krótkie przypomnienie',
    title: 'Jak to działa',
    steps: {
      sign_up: {
        emoji: '📲',
        title: 'Zarejestruj się za darmo',
        desc: 'Utwórz konto w 30 sekund.',
      },
      order: {
        emoji: '🍔',
        title: 'Zamawiaj i zdobywaj',
        desc_one: '1 pkt za {{amount}} — śledzone automatycznie.',
        desc_few: '{{count}} pkt za {{amount}} — naliczane automatycznie.',
        desc_many: '{{count}} pkt za {{amount}} — naliczane automatycznie.',
        desc_other: '{{count}} pkt za {{amount}} — śledzone automatycznie.',
      },
      build: {
        emoji: '⭐',
        title: 'Zbieraj punkty',
        desc: 'Realizuj od {{minPoints}} pkt. Ważne {{lifetime}} dni.',
      },
      save: {
        emoji: '🎁',
        title: 'Oszczędzaj przy kasie',
        desc: 'Do {{maxAmount}} zniżki — naliczane natychmiast.',
      },
      repeat: {
        emoji: '🔄',
        title: 'Zamawiaj i oszczędzaj',
        desc: 'Każde zamówienie zwiększa Twoje saldo.',
      },
    },
  },
  faq: {
    eyebrow: 'Pytania?',
    title: 'Często zadawane',
    items: {
      earn: {
        q: 'Jak zdobywam punkty?',
        a_one:
          'Zdobywasz 1 punkt za każde wydane {{amount}}. Punkty są automatycznie dodawane do Twojego konta po każdym zamówieniu — bez skanowania ani kodów.',
        a_few:
          'Zdobywasz {{count}} punkty za każde wydane {{amount}}. Punkty są dodawane automatycznie do Twojego konta po każdym zamówieniu — bez skanowania i kodów.',
        a_many:
          'Zdobywasz {{count}} punktów za każde wydane {{amount}}. Punkty są dodawane automatycznie do Twojego konta po każdym zamówieniu — bez skanowania i kodów.',
        a_other:
          'Zdobywasz {{count}} punktów za każde wydane {{amount}}. Punkty są automatycznie dodawane do Twojego konta po każdym zamówieniu — bez skanowania ani kodów.',
      },
      redeem: {
        q: 'Kiedy mogę zacząć realizować punkty?',
        a: 'Możesz zacząć realizować punkty po osiągnięciu {{minPoints}} punktów. Użyj ich przy kasie, aby zmniejszyć kwotę zamówienia.',
      },
      max: {
        q: 'Ile mogę zaoszczędzić na zamówieniu?',
        a: 'Możesz zrealizować do {{maxPoints}} punktów ({{maxAmount}}) na zamówienie. To maksymalna zniżka, którą możesz zastosować przy jednym zamówieniu.',
      },
      validity: {
        q: 'Jak długo ważne są punkty?',
        a: 'Punkty są ważne przez {{lifetime}} dni od momentu zdobycia. Wykorzystaj je przed wygaśnięciem!',
      },
    },
  },
};
